import { render, staticRenderFns } from "./Widget.vue?vue&type=template&id=5aba492e&scoped=true&lang=html&"
import script from "./Widget.vue?vue&type=script&lang=js&"
export * from "./Widget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aba492e",
  null
  
)

export default component.exports